module.exports = __webpack_public_path__ + "static/media/Cats eyes 07_SVENSKA-mixdown.a94b06c8.mp3";